<template>
  <LoginForm />
</template>
<script>
import LoginForm from '../components/Auth/Login'
export default {
  name: 'Login',
  components: {
    LoginForm
  }
}
</script>
